import { Link } from "wouter";
import { Card, CardContent } from "@/components/ui/card";
import { ShieldAlert } from "lucide-react";

interface AccessDeniedProps {
  /** Optional override for the explanatory line. */
  message?: string;
}

export default function AccessDenied({ message }: AccessDeniedProps) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <ShieldAlert className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-gray-900">403 — Access Denied</h1>
          </div>

          <p className="mt-2 text-sm text-gray-600">
            {message ??
              "You don’t have access to this section. If you believe this is a mistake, contact your administrator."}
          </p>

          <Link
            href="/threads"
            className="mt-6 inline-block rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Back to Home
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
